import {
  DatabaseService,
  InventoryLedger,
  InventoryLedgerData,
  InventoryLedgerRepository,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getInventoryLedgerRepository(
  databaseService: DatabaseService,
): InventoryLedgerRepository {
  return getGenericRepository<InventoryLedger, InventoryLedgerData>(
    () => DatabaseCollection.INVENTORY_LEDGER,
    databaseService,
  );
}
